import { render, staticRenderFns } from "./MakerStudioView.vue?vue&type=template&id=139e3a56&scoped=true"
import script from "./MakerStudioView.vue?vue&type=script&lang=js"
export * from "./MakerStudioView.vue?vue&type=script&lang=js"
import style0 from "./MakerStudioView.vue?vue&type=style&index=0&id=139e3a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e3a56",
  null
  
)

export default component.exports